import {
  SET_AGENT_WHATSAPP_CAMPAIGNS,
  RESET_AGENT_WHATSAPP_CAMPAIGNS,
} from '../../mutation-types';
import AgentWhatsAppCampaignsService from '../../../services/agent-whatsapp-campaigns-service';

const actions = {
  getAgentWhatsappCampaigns({ commit }, agentId) {
    return AgentWhatsAppCampaignsService.getAgentWhatsappCampaigns(
      agentId,
    ).then((res) => {
      commit(SET_AGENT_WHATSAPP_CAMPAIGNS, res.data);
    });
  },

  reset({ commit }) {
    commit(RESET_AGENT_WHATSAPP_CAMPAIGNS);
  },
};

export default actions;
